import Bugsnag from "@bugsnag/js";
import { IOfferModeWithFSecure } from "@nju/data-access-portal-offers";
import {
  changeMsisdnOrchestrator,
  changeSimEsimOrchestrator,
  fsecureOrchestrator,
  ftthOrchestrator,
  mobileOrchestrator,
  multiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { client } from "@nju/http-client";
import { ICancelOrderResult, IReason, IReasonDetails } from "./types";

const modeToOrchestratorMap = {
  ftth: ftthOrchestrator,
  fsecure: fsecureOrchestrator,
  mobile: mobileOrchestrator,
  postpaid: multiOrderOrchestrator,
  changeMsisdn: changeMsisdnOrchestrator,
  changeSimEsim: changeSimEsimOrchestrator,
  multiOrder: multiOrderOrchestrator,
} as const;

interface IParams {
  reason: IReason;
  orchestratorId: string;
  reasonDetails?: IReasonDetails;
  mode: IOfferModeWithFSecure | "changeMsisdn" | "changeSimEsim" | "multiOrder";
}

export async function cancelOrder(props: IParams): Promise<ICancelOrderResult> {
  const { orchestratorId, mode, ...json } = props;
  const serverResponse = modeToOrchestratorMap[mode];

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/ORDER_CANCEL`,
    {
      method: "post",
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      json,
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
